module.exports = __webpack_public_path__ + "img/more3.b156152f.png";